
export function getMaterialDisplayName(name: string | undefined | null, colorName: string | null): string {
    if (!name) {
        return '';
    }

    if (!colorName) {
        return name;
    }

    const naturals = ['naturale', 'természetes', 'natürlich', 'naravno', 'natural', 'natur'];
    
    let base = name.replace(/\s*-.*$/, '').trimEnd();
    
    for (const word of naturals) {
        base = base.replace(new RegExp(`\\s*\\b${word}\\b\\s*`, 'gi'), ' ').trim();
    }
    
    return `${base} - ${colorName}`;
}